import { Popover } from 'antd';
import PopoverContainer from 'components/common/assign-popover/PopoverContainer';
import { observer } from 'mobx-react-lite';
import styled from 'styled-components';
import { theme } from '@tools/ui-utils/theme.util';

const PopoverStyle = styled(Popover)`
  & .tooltip-arrow {
    display: none !important;
  }
`;

export const SectionSplitter = styled.hr`
  width: 248px;
  margin-top: 13px;
  border-top: 1px solid ${theme.colors.gray.grayLight};
`;

type IProps = {
  width?: number;
  top: number;
  left: number;
  content: React.ReactNode;
};

export const SideMenuPopover: React.FC<React.PropsWithChildren<IProps>> = observer((props) => {
  return (
    <PopoverContainer width={props.width} top={props.top} left={props.left}>
      <PopoverStyle
        placement="right"
        getPopupContainer={(triggerNode) => triggerNode}
        trigger="click"
        content={props.content}
      >
        {props.children}
      </PopoverStyle>
    </PopoverContainer>
  );
});
